import { TIFFormDataProps, useTIFFormData } from "../../../../hooks";
import { Col, Row } from "react-bootstrap";
import { getValueOrBlank } from "../../../../helper-functions";
import { AutoCol } from "../../../../component-library";
import { ComponentProps, FC } from "react";

const ValueCol: FC<ComponentProps<typeof Col>> = ({ children, ...props }) => {
    return (
        <Col className="mb-0" style={{ whiteSpace: "nowrap", minWidth: "fit-content", fontSize: "12px" }} {...props}>
            {children}
        </Col>
    );
};

const LabelCol: FC<ComponentProps<typeof Col> & { wide?: boolean }> = ({ children, wide, ...props }) => {
    return (
        <Col
            className="mb-0 pe-0 d-flex justify-content-end"
            style={{
                whiteSpace: "nowrap",
                minWidth: wide ? "150px" : "80px",
                fontSize: "12px",
            }}
            {...props}
        >
            {children}
        </Col>
    );
};

const SerologyEntry = ({
    label,
    value,
    wideLabel,
}: {
    label: string;
    value: string | undefined;
    wideLabel?: boolean;
}) => {
    return (
        <>
            <LabelCol wide={wideLabel}>{label}</LabelCol>
            <ValueCol>{value}</ValueCol>
        </>
    );
};

export function TIFSerologies({ tissueId }: Readonly<TIFFormDataProps>) {
    const { donor, getSerologyValues } = useTIFFormData({ tissueId });

    return (
        <>
            <div style={{ fontWeight: "bold", fontSize: "14px" }}>Serology:</div>
            <Row>
                <AutoCol style={{ minWidth: "fit-content" }}>
                    <Row>
                        <SerologyEntry label="HBsAG" value={getSerologyValues(donor?.serologies?.data?.hbsag)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="HBcAB" value={getSerologyValues(donor?.serologies?.data?.hbcab)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="HBV NAT" value={getSerologyValues(donor?.serologies?.data?.hbvNat)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="HCV Ab" value={getSerologyValues(donor?.serologies?.data?.hcvab)} />
                    </Row>
                    <Row>
                        <SerologyEntry
                            label={donor?.serologies?.data?.testName1 ?? ""}
                            value={getSerologyValues(donor?.serologies?.data?.result1, true)}
                        />
                    </Row>
                </AutoCol>
                <AutoCol>
                    <Row>
                        <SerologyEntry label="HCV" value={getSerologyValues(donor?.serologies?.data?.hcv)} wideLabel />
                    </Row>
                    <Row>
                        <SerologyEntry
                            label="HIV 1/2 NAT"
                            value={getSerologyValues(donor?.serologies?.data?.hiv12Nat)}
                            wideLabel
                        />
                    </Row>
                    <Row>
                        <SerologyEntry
                            label="HIV 1/2 Plus O Ab"
                            value={getSerologyValues(donor?.serologies?.data?.hivPlusOAb)}
                            wideLabel
                        />
                    </Row>
                    <Row>
                        <SerologyEntry label="RPR" value={getSerologyValues(donor?.serologies?.data?.rpr)} wideLabel />
                    </Row>
                    <Row>
                        <SerologyEntry
                            label={donor?.serologies?.data?.testName2}
                            value={getSerologyValues(donor?.serologies?.data?.result2, true)}
                            wideLabel
                        />
                    </Row>
                </AutoCol>
                <AutoCol style={{ minWidth: "fit-content" }}>
                    <Row>
                        <SerologyEntry label="CAPTIA" value={getSerologyValues(donor?.serologies?.data?.captia)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="HTLV I/II" value={getSerologyValues(donor?.serologies?.data?.htlv)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="CMV" value={getSerologyValues(donor?.serologies?.data?.cmv)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="Toxo" value={getSerologyValues(donor?.serologies?.data?.toxo)} />
                    </Row>
                </AutoCol>
                <AutoCol style={{ minWidth: "fit-content" }}>
                    <Row>
                        <SerologyEntry label="TPHA" value={getSerologyValues(donor?.serologies?.data?.tpha)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="WNV" value={getSerologyValues(donor?.serologies?.data?.wnv)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="EBV" value={getSerologyValues(donor?.serologies?.data?.ebv)} />
                    </Row>
                    <Row>
                        <SerologyEntry label="ABORh" value={getValueOrBlank(donor?.serologies?.data?.aborh)} />
                    </Row>
                </AutoCol>
            </Row>
            <hr className="my-1" />
        </>
    );
}
